export default __webpack_public_path__ + "static/media/plus-2.46ffc7e9.svg";